import React from 'react'

const Pytm2 = () => {
    return (
        <div className='container'>
            <h1>Reverse words in a given string</h1>
            <p>Example: Let the input string be “i like this program very much”. The function should change the string to “much very program this like i”</p>
            <p><strong>Examples</strong>:&nbsp;</p>
            <blockquote><p><strong>Input</strong>: s = “getting good at coding needs a lot of practice”&nbsp;<br/>
            <strong>Output</strong>: s = “practice of lot a needs coding at good getting”&nbsp;<br/>
            &nbsp;</p></blockquote>
            <p><strong>Algorithm</strong>:&nbsp;&nbsp;</p>
            <ul><li>Initially, reverse the individual words of the given string one by one, for the above example, after reversing individual words the string should be “i ekil siht margorp yrev hcum”.</li>
            <li>Reverse the whole string from start to end to get the desired output “much very program this like i” in the above example.</li>
            </ul>

             <div class="tabs">
    <input type="radio" name="tab" id="tab1" />
    <label for="tab1">CPP</label>
    <input type="radio" name="tab" id="tab2"/>
    <label for="tab2">Java </label>
    <input type="radio" name="tab" id="tab3"/>
    <label for="tab3">Python</label>
    <input type="radio" name="tab" id="tab3"/>
    <label for="tab4">C</label>

  
    <div class="tab-content-wrapper">
      <div id="tab-content-1" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code class="comments">// C++ program to reverse a string</code></div>
    <div class="line number2 index1 alt1"><code class="preprocessor">#include &lt;bits/stdc++.h&gt;</code></div>
    <div class="line number3 index2 alt2"><code class="keyword bold">using</code> <code
            class="keyword bold">namespace</code> <code class="plain">std;</code></div>
    <div class="line number4 index3 alt1">&nbsp;</div>
    <div class="line number5 index4 alt2"><code class="comments">// Function to reverse words*/</code></div>
    <div class="line number6 index5 alt1"><code class="keyword bold">void</code> <code
            class="plain">reverseWords(string s)</code></div>
    <div class="line number7 index6 alt2"><code class="plain">&#123;</code></div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// temporary vector to store all words</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">vector&lt;string&gt; tmp;</code></div>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">string str = </code><code class="string">""</code><code class="plain">;</code></div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">for</code> <code class="plain">(</code><code class="color1 bold">int</code> <code
            class="plain">i = 0; i &lt; s.length(); i++)</code></div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number14 index13 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number15 index14 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Check if we encounter space</code></div>
    <div class="line number16 index15 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// push word(str) to vector</code></div>
    <div class="line number17 index16 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// and make str NULL</code></div>
    <div class="line number18 index17 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(s[i] == </code><code class="string">' '</code><code
            class="plain">)</code></div>
    <div class="line number19 index18 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number20 index19 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">tmp.push_back(str);</code></div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">str = </code><code class="string">""</code><code class="plain">;</code></div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number23 index22 alt2">&nbsp;</div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Else add character to</code></div>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// str to form current word</code></div>
    <div class="line number26 index25 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">else</code></div>
    <div class="line number27 index26 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">str += s[i];</code></div>
    <div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Last word remaining,add it to vector</code></div>
    <div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">tmp.push_back(str);</code></div>
    <div class="line number32 index31 alt1">&nbsp;</div>
    <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Now print from last to first in vector</code></div>
    <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">i;</code></div>
    <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">for</code> <code class="plain">(i = tmp.size() - 1; i &gt; 0; i--)</code></div>
    <div class="line number36 index35 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; tmp[i] &lt;&lt; </code><code class="string">" "</code><code
            class="plain">;</code></div>
    <div class="line number37 index36 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Last word remaining,print it</code></div>
    <div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; tmp[0] &lt;&lt; endl;</code></div>
    <div class="line number39 index38 alt2"><code class="plain">&#125;</code></div>
    <div class="line number40 index39 alt1">&nbsp;</div>
    <div class="line number41 index40 alt2"><code class="comments">// Driver Code</code></div>
    <div class="line number42 index41 alt1"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
    <div class="line number43 index42 alt2"><code class="plain">&#123;</code></div>
    <div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">string s = </code><code class="string">"i like this program very much"</code><code
            class="plain">;</code></div>
    <div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">reverseWords(s);</code></div>
    <div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">0;</code></div>
    <div class="line number47 index46 alt2"><code class="plain">&#125;</code></div>
</div>
     </div>
      <div id="tab-content-2" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code class="comments">// Java program to</code></div>
    <div class="line number2 index1 alt1"><code class="comments">// reverse a String</code></div>
    <div class="line number3 index2 alt2"><code class="keyword">import</code> <code class="plain">java.util.*;</code>
    </div>
    <div class="line number4 index3 alt1"><code class="keyword">class</code> <code class="plain">NooB&#123;</code></div>
    <div class="line number5 index4 alt2">&nbsp;</div>
    <div class="line number6 index5 alt1"><code class="comments">// Reverse the letters</code></div>
    <div class="line number7 index6 alt2"><code class="comments">// of the word</code></div>
    <div class="line number8 index7 alt1"><code class="keyword">static</code> <code class="keyword">void</code> <code
            class="plain">reverse(</code><code class="keyword">char</code> <code class="plain">str[],</code></div>
    <div class="line number9 index8 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">start,</code></div>
    <div class="line number10 index9 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">end)</code></div>
    <div class="line number11 index10 alt2"><code class="plain">&#123;</code></div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="comments">// Temporary variable</code></div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="comments">// to store character</code></div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="keyword">char</code> <code class="plain">temp;</code></div>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="keyword">while</code> <code class="plain">(start &lt;= end)</code></div>
    <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Swapping the first</code></div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// and last character</code></div>
    <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">temp = str[start];</code></div>
    <div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">str[start] = str[end];</code></div>
    <div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">str[end] = temp;</code></div>
    <div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">start++;</code></div>
    <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">end--;</code></div>
    <div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number26 index25 alt1"><code class="plain">&#125;</code></div>
    <div class="line number27 index26 alt2"><code class="comments">// Function to reverse words</code></div>
    <div class="line number28 index27 alt1"><code class="keyword">static</code> <code class="keyword">char</code><code
            class="plain">[] reverseWords(</code><code class="keyword">char</code> <code class="plain">[]s)</code></div>
    <div class="line number29 index28 alt2"><code class="plain">&#123;</code></div>
    <div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="comments">// Reversing individual words as</code></div>
    <div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="comments">// explained in the first step</code></div>
    <div class="line number32 index31 alt1">&nbsp;</div>
    <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">start = </code><code class="value">0</code><code
            class="plain">;</code></div>
    <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="keyword">for</code> <code class="plain">(</code><code class="keyword">int</code> <code
            class="plain">end = </code><code class="value">0</code><code
            class="plain">; end &lt; s.length; end++)</code></div>
    <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// If we see a space, we</code></div>
    <div class="line number37 index36 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// reverse the previous</code></div>
    <div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// word (word between</code></div>
    <div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// the indexes start and end-1</code></div>
    <div class="line number40 index39 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// i.e., s[start..end-1]</code></div>
    <div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(s[end] == </code><code class="string">' '</code><code
            class="plain">)</code></div>
    <div class="line number42 index41 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number43 index42 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">reverse(s, start, end);</code></div>
    <div class="line number44 index43 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">start = end + </code><code class="value">1</code><code class="plain">;</code></div>
    <div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number47 index46 alt2">&nbsp;</div>
    <div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="comments">// Reverse the last word</code></div>
    <div class="line number49 index48 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">reverse(s, start, s.length - </code><code class="value">1</code><code class="plain">);</code>
    </div>
    <div class="line number50 index49 alt1">&nbsp;</div>
    <div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="comments">// Reverse the entire String</code></div>
    <div class="line number52 index51 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">reverse(s, </code><code class="value">0</code><code class="plain">, s.length - </code><code
            class="value">1</code><code class="plain">);</code></div>
    <div class="line number53 index52 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="plain">s;</code></div>
    <div class="line number54 index53 alt1"><code class="plain">&#125;</code></div>
    <div class="line number55 index54 alt2">&nbsp;</div>
    <div class="line number56 index55 alt1"><code class="comments">// Driver Code</code></div>
    <div class="line number57 index56 alt2"><code class="keyword">public</code> <code class="keyword">static</code>
        <code class="keyword">void</code> <code class="plain">main(String[] args)</code></div>
    <div class="line number58 index57 alt1"><code class="plain">&#123;</code></div>
    <div class="line number59 index58 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">String s = </code><code class="string">"i like this program very much "</code><code
            class="plain">;</code></div>
    <div class="line number60 index59 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="keyword">char</code> <code class="plain">[]p = reverseWords(s.toCharArray());</code></div>
    <div class="line number61 index60 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">System.out.print(p);</code></div>
    <div class="line number62 index61 alt1"><code class="plain">&#125;</code></div>
    <div class="line number63 index62 alt2"><code class="plain">&#125;</code></div>
    <div class="line number64 index63 alt1">&nbsp;</div>
    <div class="line number65 index64 alt2"><code class="comments">// This code is contributed by gauravrajput1</code>
    </div>
</div>
        </div>
      <div id="tab-content-3" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code class="comments"># Python3 program to reverse a string</code></div>
    <div class="line number2 index1 alt1">&nbsp;</div>
    <div class="line number3 index2 alt2"><code class="comments"># Function to reverse each word in the string</code>
    </div>
    <div class="line number4 index3 alt1"><code class="keyword">def</code> <code
            class="plain">reverse_word(s, start, end):</code></div>
    <div class="line number5 index4 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">while</code> <code class="plain">start &lt; end:</code></div>
    <div class="line number6 index5 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s[start], s[end] </code><code class="keyword">=</code> <code
            class="plain">s[end], s[start]</code></div>
    <div class="line number7 index6 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">start </code><code class="keyword">=</code> <code class="plain">start </code><code
            class="keyword">+</code> <code class="value">1</code></div>
    <div class="line number8 index7 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">end </code><code class="keyword">-</code><code class="keyword">=</code> <code
            class="value">1</code></div>
    <div class="line number9 index8 alt2">&nbsp;</div>
    <div class="line number10 index9 alt1">&nbsp;</div>
    <div class="line number11 index10 alt2"><code class="plain">s </code><code class="keyword">=</code> <code
            class="string">"i like this program very much"</code></div>
    <div class="line number12 index11 alt1">&nbsp;</div>
    <div class="line number13 index12 alt2"><code
            class="comments"># Convert string to list to use it as a char array</code></div>
    <div class="line number14 index13 alt1"><code class="plain">s </code><code class="keyword">=</code> <code
            class="functions">list</code><code class="plain">(s)</code></div>
    <div class="line number15 index14 alt2"><code class="plain">start </code><code class="keyword">=</code> <code
            class="value">0</code></div>
    <div class="line number16 index15 alt1"><code class="keyword">while</code> <code class="color1">True</code><code
            class="plain">:</code></div>
    <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># We use a try catch block because for</code></div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># the last word the list.index() function</code></div>
    <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># returns a ValueError as it cannot find</code></div>
    <div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># a space in the list</code></div>
    <div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">try</code><code class="plain">:</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Find the next space</code></div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">end </code><code class="keyword">=</code> <code class="plain">s.index(</code><code
            class="string">' '</code><code class="plain">, start)</code></div>
    <div class="line number25 index24 alt2">&nbsp;</div>
    <div class="line number26 index25 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Call reverse_word function</code></div>
    <div class="line number27 index26 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># to reverse each word</code></div>
    <div class="line number28 index27 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">reverse_word(s, start, end </code><code class="keyword">-</code> <code
            class="value">1</code><code class="plain">)</code></div>
    <div class="line number29 index28 alt2">&nbsp;</div>
    <div class="line number30 index29 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">#Update start variable</code></div>
    <div class="line number31 index30 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">start </code><code class="keyword">=</code> <code class="plain">end </code><code
            class="keyword">+</code> <code class="value">1</code></div>
    <div class="line number32 index31 alt1">&nbsp;</div>
    <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">except</code> <code class="plain">ValueError:</code></div>
    <div class="line number34 index33 alt1">&nbsp;</div>
    <div class="line number35 index34 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Reverse the last word</code></div>
    <div class="line number36 index35 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">reverse_word(s, start, </code><code class="functions">len</code><code
            class="plain">(s) </code><code class="keyword">-</code> <code class="value">1</code><code
            class="plain">)</code></div>
    <div class="line number37 index36 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">break</code></div>
    <div class="line number38 index37 alt1">&nbsp;</div>
    <div class="line number39 index38 alt2"><code class="comments"># Reverse the entire list</code></div>
    <div class="line number40 index39 alt1"><code class="plain">s.reverse()</code></div>
    <div class="line number41 index40 alt2">&nbsp;</div>
    <div class="line number42 index41 alt1"><code class="comments"># Convert the list back to</code></div>
    <div class="line number43 index42 alt2"><code class="comments"># string using string.join() function</code></div>
    <div class="line number44 index43 alt1"><code class="plain">s </code><code class="keyword">=</code> <code
            class="plain">"".join(s)</code></div>
    <div class="line number45 index44 alt2">&nbsp;</div>
    <div class="line number46 index45 alt1"><code class="functions">print</code><code class="plain">(s)</code></div>
    <div class="line number47 index46 alt2">&nbsp;</div>
    <div class="line number48 index47 alt1"><code class="comments"># Solution contributed by Prem Nagdeo</code></div>
</div>
     </div>
      <div id="tab-content-4" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code class="comments">// C program to reverse a string</code></div>
    <div class="line number2 index1 alt1"><code class="preprocessor">#include &lt;stdio.h&gt;</code></div>
    <div class="line number3 index2 alt2">&nbsp;</div>
    <div class="line number4 index3 alt1"><code class="comments">// Function to reverse any sequence</code></div>
    <div class="line number5 index4 alt2"><code class="comments">// starting with pointer begin and</code></div>
    <div class="line number6 index5 alt1"><code class="comments">// ending with pointer end</code></div>
    <div class="line number7 index6 alt2"><code class="keyword bold">void</code> <code
            class="plain">reverse(</code><code class="color1 bold">char</code><code class="plain">* begin, </code><code
            class="color1 bold">char</code><code class="plain">* end)</code></div>
    <div class="line number8 index7 alt1"><code class="plain">&#123;</code></div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">char</code> <code class="plain">temp;</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">while</code> <code class="plain">(begin &lt; end) &#123;</code></div>
    <div class="line number11 index10 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">temp = *begin;</code></div>
    <div class="line number12 index11 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">*begin++ = *end;</code></div>
    <div class="line number13 index12 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">*end-- = temp;</code></div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number15 index14 alt2"><code class="plain">&#125;</code></div>
    <div class="line number16 index15 alt1">&nbsp;</div>
    <div class="line number17 index16 alt2"><code class="comments">// Function to reverse words*/</code></div>
    <div class="line number18 index17 alt1"><code class="keyword bold">void</code> <code
            class="plain">reverseWords(</code><code class="color1 bold">char</code><code class="plain">* s)</code></div>
    <div class="line number19 index18 alt2"><code class="plain">&#123;</code></div>
    <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">char</code><code class="plain">* word_begin = s;</code></div>
    <div class="line number21 index20 alt2">&nbsp;</div>
    <div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Word boundary</code></div>
    <div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">char</code><code class="plain">* temp = s;</code></div>
    <div class="line number24 index23 alt1">&nbsp;</div>
    <div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Reversing individual words as</code></div>
    <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// explained in the first step</code></div>
    <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">while</code> <code class="plain">(*temp) &#123;</code></div>
    <div class="line number28 index27 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">temp++;</code></div>
    <div class="line number29 index28 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(*temp == </code><code class="string">'\0'</code><code
            class="plain">) &#123;</code></div>
    <div class="line number30 index29 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">reverse(word_begin, temp - 1);</code></div>
    <div class="line number31 index30 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number32 index31 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">else</code> <code class="keyword bold">if</code> <code
            class="plain">(*temp == </code><code class="string">' '</code><code class="plain">) &#123;</code></div>
    <div class="line number33 index32 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">reverse(word_begin, temp - 1);</code></div>
    <div class="line number34 index33 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">word_begin = temp + 1;</code></div>
    <div class="line number35 index34 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number37 index36 alt2">&nbsp;</div>
    <div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Reverse the entire string</code></div>
    <div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">reverse(s, temp - 1);</code></div>
    <div class="line number40 index39 alt1"><code class="plain">&#125;</code></div>
    <div class="line number41 index40 alt2">&nbsp;</div>
    <div class="line number42 index41 alt1"><code class="comments">// Driver Code</code></div>
    <div class="line number43 index42 alt2"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
    <div class="line number44 index43 alt1"><code class="plain">&#123;</code></div>
    <div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">char</code> <code class="plain">s[] = </code><code
            class="string">"i like this program very much"</code><code class="plain">;</code></div>
    <div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">char</code><code class="plain">* temp = s;</code></div>
    <div class="line number47 index46 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">reverseWords(s);</code></div>
    <div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">printf</code><code class="plain">(</code><code class="string">"%s"</code><code
            class="plain">, s);</code></div>
    <div class="line number49 index48 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">0;</code></div>
    <div class="line number50 index49 alt1"><code class="plain">&#125;</code></div>
</div>
     </div>
     </div>
  </div>
  <br /> <br /> <br /> <br /> <br />
        </div>
    )
}

export default Pytm2
